<template>
  <div class="index">
    <!-- banner -->
    <slider :sliderData="sliderData"></slider>
    <!-- 无图新闻(学院新闻+通知公告)) -->
    <div class="wutuDiv1">
      <div class="w69">
        <xwdt
          :xwdtList="xwdtList"
          moreLink="/list.html?HType=2&CId=6584"
        ></xwdt>
        <tzgg
          :tzggList="tzggList"
          moreLink="/list.html?HType=2&CId=6278"
        ></tzgg>
        <!-- <xsjl
          :xsjlList="xsjlList"
          moreLink="/list.html?HType=2&CId=6279"
        ></xsjl> -->
      </div>
    </div>
    <!-- 无图新闻（职称评聘+师资建设） -->
    <div class="wutuDiv2">
      <div class="w69">
        <cgzs
          :cgzsList="cgzsList"
          moreLink="/list.html?HType=2&CId=6282"
        ></cgzs>
        <div class="Listtong-home">
          <div class="kslj top_title">
            <div class="top_text">
              <p>快速链接</p>
              <span>QUICK LINKS</span>
            </div>
          </div>
          <div class="kstd_img">
            <a href="http://jku.1w1w.com:8116/portal/#/login" target="_blank">
              <img src="../assets/img/kyglxt.png" alt="" />
            </a>
            <!-- <a href="javascript:;" target="_blank">
                  <img src="../assets/img/bslc.png" alt="" />
                </a> -->
            <a href="list.html?HType=4&CId=6286">
              <img src="../assets/img/xzzx.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../assets/css/index.css";
import "../assets/js/init.js";
import "../assets/js/wow.js";
import slider from "@/components/slider";
import xwdt from "@/components/xwdt";
import xsjl from "@/components/xsjl";
import tzgg from "@/components/tzgg";
import cgzs from "@/components/cgzs";
export default {
  name: "index",
  components: {
    slider,
    xwdt,
    tzgg,
    xsjl,
    cgzs
  },
  data() {
    return {
      baseUrl: "this.baseUrl",
      sliderData: [],
      xwdtList: [],
      tzggList: [],
      xsjlList: [],
      jxdtList: []
    };
  },
  created() {
    this.$root.$children["0"].$children["0"].menuListOne.forEach(
      element => (element.On = false)
    );
    this.sliderData = this.Base.GetFilesInfoByCid(6287, 1, "", 6, 1); //banner
    this.xwdtList = this.Base.GetNewsInfoByCid(6584, false, 1, "", 5); //新闻动态
    this.tzggList = this.Base.GetNewsInfoByCid(6278, false, 1, "", 5); //通知公告
    this.xsjlList = this.Base.GetNewsInfoByCid(6279, false, 1, "", 5); //学术交流
    this.cgzsList = this.Base.GetNewsInfoByCid(6282, false, 1, "", 4); //成果展示
  }
};
</script>
<style lang="less" scoped>
.formBox {
  width: 5.45rem;
  margin: 0 auto;
  form {
    margin-top: 0.54rem;
  }
  /deep/.el-select {
    width: 100%;
    margin-bottom: 0.4rem;
    input {
      height: 0.8rem;
      line-height: 0.8rem;
      padding-left: 0.6rem;
    }
    .el-input__suffix {
      right: 0.33rem;
    }
  }
}
.Listtong-home {
  .top_title {
    width: 6.9rem;
    height: 1.1rem;
    background-color: #f9f9f9;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    margin-bottom: 0.25rem;
    .top_text {
      padding-left: 0.4rem;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 0.02rem;
        height: 100%;
        background-color: #32454f;
        left: 0.3rem;
      }
      p {
        font-size: 0.26rem;
        font-weight: 600;
        font-stretch: normal;
        line-height: 0.26rem;
        letter-spacing: 0.02rem;
        color: #32454f;
        margin-bottom: 0.1rem;
      }
      span {
        font-size: 0.16rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.2rem;
        letter-spacing: 0rem;
        color: #32454f;
        display: block;
      }
    }
  }
  .kstd_img {
    a {
      display: block;
      width: 5.25rem;
      height: 1.21rem;
      background-color: #ebf8ff;
      border-radius: 4px;
      margin: 0 auto;
      margin-bottom: 0.7rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue